'use strict';

import './Animation.less';

import React from 'react';
import PropTypes from 'prop-types';

export default class Animation extends React.Component {
	constructor(props) {
		super(props);

		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.onMouseLeave = this.onMouseLeave.bind(this);
	}

	onMouseEnter() {
		this.animation.play();
	}

	onMouseLeave() {
		this.animation.pause();
	}

	loadAnimation() {
		if (typeof window !== 'undefined') {
			const lottie = require('lottie-web');
			this.animation = lottie.loadAnimation({
				container: this.dom,
				renderer: this.props.renderer,
				loop: this.props.loop,
				autoplay: this.props.autoplay,
				playOnHover: this.props.playOnHover,
				path: '/libraries/animations/' + this.props.name + '.json'
			});
		}
	}

	componentDidMount() {
		this.loadAnimation();
		this.componentDidUpdate();
	}

	componentDidUpdate() {
		if (typeof window !== 'undefined') {
			if (this.props.autoplay) {
				this.animation.play();
			} else {
				this.animation.pause();
			}
		}
	}

	render() {
		return <div className="Animation" ref={e => (this.dom = e)} />;
	}
}

Animation.propTypes = {
	name: PropTypes.string.isRequired,
	renderer: PropTypes.string,
	loop: PropTypes.bool,
	autoplay: PropTypes.bool,
	playOnHover: PropTypes.bool
};

Animation.defaultProps = {
	renderer: 'svg',
	loop: false,
	autoplay: true,
	playOnHover: false
};
